export const commonPacksContainerQuery = '(min-width: 854px)';
